import SharedI18n from "./sharedI18n";

const en: SharedI18n = {
  namespace: "shared",
  table:{
    selected: "Selected",
    rows: "Rows per page:",
    of: "of"
  },
  navmenu: {
    logo: "/image/Logo.en.png",
    language: "Russian-RU",
    exit: "Exit",
    documents: "Documents",
    admin: "Administration",
    company: "Companies",
    users: "Users",
    usersGroup: "Users groups",
    settings: "Settings",
    downloads: "Downloads...",
    downloadLogs: "Download logs",
    audit: "Audit",
    profile: "Profile",
    tasks: "Tasks",
    editableDocuments: "Editable documents",
    showMore: "Show more",
    myTasks: "My Tasks",
    myWork: "My Work",
    more: "More",
    accessRestrictionStamp: "Effects of access restrictions",
  },
  breadcrumb: {
    home: "ASONIKA-CDE",
    "/documents": "Documents",
    "/users": "Users",
    "/usersGroup": "Users groups",
    "/company": "Company",
    "/settings": "Settings",
    "/audit": "Audit",
    "/profile": "Profile",
    "/changePass": "Change password",
    "/changePersonalData": "Change personal data",
    "/changeAvatar": "Change avatar",
    "/tasks": "Tasks",
    "/editableDocuments": "Editable documents",
    "/myTasks": "My Tasks",
    "/accessRestrictionStamp": "Effects of access restrictions",
  },
  footer: {
    asonika: "Scientific Research institute 'ASONIKA', Ltd",
    site: "Site:",
    support: "Support:",
    link: "http://asonika.com/",
  },
  dropmenu: {
    emptyLock: "No editable documents",
    myTasks: "My tasks",
    docLock: "Editable documents",
    undo: "Cancel file editing",
    commit: "Complete file editing",
    toDocuments: "Go to document",
  },
  statusList: {
    New: "New",
    Active: "In work",
    Closed: "Closed",
    Resolved: "Completed",
    Canceled: "Canceled",
    Paused: "Paused",
  },
};

export default en;
